<template>
  <div class="Users">
    <h3 class="mb-3 text-right">Colocaciones Públicas en la web</h3>
    <b-card>
      <b-container fluid>
        <!-- User Interface controls -->
        <b-row align-v="center" align-h="between" class="mb-2">
          <b-col sm="4" md="6" cols="6" lg="4" class="my-1">
            <b-button pill class="btn-card-color text-font-white" @click="modalSave=true">Agregar colocación en la web</b-button>
          </b-col>
          <b-col sm="4" md="6" cols="6" lg="4" class="my-1">
            <b-form-group label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
              <b-input-group size="md">
                <b-form-input v-model="filter" type="search" id="filterInput"
                  placeholder="Buscar por nombre o correo"></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col sm="4" md="8" cols="12" lg="4" class="my-1">
            <b-form-group label="Por Página" label-cols-sm="6" label-cols-md="3" label-cols-lg="4" label-align-sm="right"
              label-size="sm" label-for="perPageSelect" class="mb-0">
              <b-form-select v-model="perPage" id="perPageSelect" size="md" :options="pageOptions"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Main table element -->
        <b-table show-empty small stacked="md" class="text-left"
          style="font-family: Montserrat; font-weight: lighter; font-size: 14px" id="my-table" :items="UsersTmp"
          :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter"
          :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection" @filtered="onFiltered" :busy="isBusy">
          <template v-slot:empty>
            <div class="mt-2 text-center">
              <h6>No hay usuarios registrados</h6>
            </div>
          </template>

          <template v-slot:table-busy>
            <div class="text-center text-dark my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="ml-2">Cargando...</strong>
            </div>
          </template>

          <template v-slot:emptyfiltered>
            <div class="my-2 text-center">
              <h6>No hay usuarios con esas especificaciones</h6>
            </div>
          </template>
           <template v-slot:cell(url_image)="row">
            <img :src=row.item.url_image class="img-fluid" style="max-width: 120px;" alt=""></template>
          <template v-slot:cell(active)="row">{{
            row.value == 0 ? "No" : "Si"
          }}</template> 

          <template v-slot:cell(actions)="row">
            <b-button title="Detalles" size="sm" variant="white" @click="userDetails(row.item)">
              <v-icon name="eye"></v-icon>
            </b-button>

            <b-button title="Desactivar usuario" @click="changeActive(row.item)" v-if="row.item.active == 1" size="sm"
              variant="white">
              <v-icon name="user-check" color="green"></v-icon>
            </b-button>
            <b-button title="Activar usuario" @click="changeActive(row.item)" v-if="row.item.active == 0" size="sm"
              variant="white">
              <v-icon name="user-times"></v-icon>
            </b-button>

            <b-button title="Eliminar" size="sm" class="mr-1" variant="white" @click="deleteUser(row.item)">
              <v-icon v-show="!hide" name="trash" color="#CF173C"></v-icon>
              <b-spinner v-show="hide" small variant="danger" class="align-middle"></b-spinner>
            </b-button>
          </template>
        </b-table>
        <b-col lg="5" class="mx-auto pt-2">
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="fill" size="md"
            class="my-0"></b-pagination>
        </b-col>
      </b-container>
    </b-card>
    <b-modal id="modal-register" ref="modal" title-class="text-font-black" title="Registro de colocación pública"
      hide-footer footer-class="text-font-black" v-model="modalUpdate">
      <b-container>
        <form ref="form" @submit.stop.prevent="onSubmitUpdate">
          <b-row>
            <b-col lg="6">
              <b-form-group label="Titutlo" label-class="text-light-black" label-for="title"
                invalid-feedback="Titulo requerido">
                <b-form-input id="title" v-model="form_update.title" required></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group label="Descripción" label-class="text-light-black" label-for="description"
                invalid-feedback="Descripción requerida">
                <b-form-input id="description" v-model="form_update.description" required></b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Agregar imagen" label-class="text-light-black" label-for="addImg"
                invalid-feedback="Imagen requerida">

              </b-form-group>
              <b-button variant="white" @click="changePicture()">
                <svg class="p-5 shadow-lg" style="background-color: #f8f8f8; border-radius: 10px"
                  xmlns="http://www.w3.org/2000/svg" height="200px" viewBox="0 0 24 24" width="200px" fill="#C4C4C4">
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path
                    d="M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z" />
                </svg>
              </b-button>

              
             
            </b-col>
            <b-col md="6">
              <label><strong>Imagen actual</strong></label>
              <img v-if="form_update.url_image" :src="form_update.url_image" height="200px" width="200px" style="border-radius: 10px" alt="" />

             
              <br>
              <br>
            </b-col>


            <b-col lg="4" v-show="!progress1"></b-col>
           
            <b-col lg="4" v-show="!progress1">
              <b-button style="border-radius: 12px; border: none" class="p-3" size="sm" @click="
                cancel = true;
              resetModal();
              ">
                <span class="text-font-white">Cancelar</span>
              </b-button>
            </b-col>
            <b-col lg="4" v-show="!progress1">
              

              <b-button style="border-radius: 12px; border: none" class="p-3" size="sm" @click="
                cancel = true;
                updatePublicInvest();
              ">
                <span class="text-font-white">Actualizar colocacion</span>
              </b-button>
            </b-col>

            <b-col>
              <div v-show="progress1" class="text-center text-primary mt-3">
                <b-spinner small class="align-middle"></b-spinner>
                <strong class="ml-2">Cargando...</strong>
              </div>
            </b-col>
          </b-row>
        </form>
      </b-container>
    </b-modal>

    <b-modal id="modal-register" ref="modal" title-class="text-font-black" title="Registro de colocación pública"
      hide-footer footer-class="text-font-black" v-model="modalSave">
      <b-container>
        <form ref="form" @submit.stop.prevent="reportPayment">
          <b-row>
            <b-col lg="6">
              <b-form-group label="Titutlo" label-class="text-light-black" label-for="title"
                invalid-feedback="Titulo requerido">
                <b-form-input id="title" v-model="title" required></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group label="Descripción" label-class="text-light-black" label-for="description"
                invalid-feedback="Descripción requerida">
                <b-form-input id="description" v-model="description" required></b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group label="Agregar imagen" label-class="text-light-black" label-for="addImg"
                invalid-feedback="Imagen requerida">

              </b-form-group>
              <b-button variant="white" v-if="!picture" @click="changePicture()">
                <svg class="p-5 shadow-lg" style="background-color: #f8f8f8; border-radius: 10px"
                  xmlns="http://www.w3.org/2000/svg" height="200px" viewBox="0 0 24 24" width="200px" fill="#C4C4C4">
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path
                    d="M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z" />
                </svg>
              </b-button>

              <img v-if="picture" :src="picture" height="200px" width="200px" style="border-radius: 10px" alt="" />

             
            </b-col>


            <b-col lg="4" v-show="!progress1"></b-col>

            <b-col lg="4" v-show="!progress1">
              <b-button style="border-radius: 12px; border: none" class="p-3" size="sm" @click="
                cancel = true;
              resetModal();
              ">
                <span class="text-font-white">Cancelar</span>
              </b-button>
            </b-col>
            <b-col lg="4" v-show="!progress1">
              

              <b-button style="border-radius: 12px; border: none" class="p-3" size="sm" @click="
                cancel = true;
                createPublicInvest();
              ">
                <span class="text-font-white">Crear colocacion</span>
              </b-button>
            </b-col>

            <b-col>
              <div v-show="progress1" class="text-center text-primary mt-3">
                <b-spinner small class="align-middle"></b-spinner>
                <strong class="ml-2">Cargando...</strong>
              </div>
            </b-col>
          </b-row>
        </form>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "InvestPublic",
  data() {
    return {
      progress: false,
      progress1: false,
      form_update:{
        title:'',
        description:'',
        img_url:''
      },
      modalSave:false,
      modalUpdate:false,
      title: "",
      description: "",
      email_register: "",
      country: "",
      state: "",
      phone: "",
      password1: "",
      password2: null,
      hide: false,
      isBusy: false,
      UsersTmp: [],
      Users: [],
      countries: [],
      countryTmp: [],
      states: [],
      stateTmp: [],
      fields: [
        {
          key: "title",
          label: "Titulo",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "description",
          label: "Descripción",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "url_image",
          label: "Imagen",
          sortable: true,
        },

        { key: "actions", label: "Acciones" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 15, 20],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],

      images: [],
      picture: null,
      file: null,
      disable: null,
      files: [],
    };
  },
  computed: {
    ...mapState({
      me: (state) => state.me,
    }),
  },
  mounted() {
    this.getDataUser();

    
  },
  methods: {
    ...mapActions([
      "createData",
      "updateData",
      "InvestPublicAll",
      "UserUpdate",
      "changeStatusData",
      "RegisterUserbyAdmin",
      "getData",
      "RegisterImageInvestP",
      "UpdateImageInvestP"
    ]),
    async changePicture() {
      const { value: file } = await Swal.fire({
        title: "Seleccionar una imagen",
        input: "file",
        inputAttributes: {
          accept: "image/*",
          "aria-label": "Upload your profile picture",
        },
      });

      if (file) {
        console.log(file);
        this.progress = true;

        const reader = new FileReader();
        reader.onload = (e) => {

          this.picture = e.target.result;
          this.form_update.url_image = e.target.result;
          this.file = file;
          this.progress = false;
        };
        console.log(file);
        reader.readAsDataURL(file);
      }
    },
    // Manejador del evento de cambio de archivo
    // uploadFile(event) {
    //   const file = event.target.file[0];
    //   this.file.push(file); // Agregar el archivo a la lista de archivos seleccionados
    // },
    // Manejador del evento de subida
    createPublicInvest() {
      if (
        this.title == "" ||
        this.description == ""
       
      ) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debes llenar todos los campos para continuar",
          icon: "warning",
        });
      } else {
        if ( this.amount <= 0){
        Swal.fire({
          title: "¡Atención!",
          text: "El monto a registrar debe ser mayor a 0",
          icon: "warning",
        });
        } else if ( !this.picture ){
          Swal.fire({
          title: "¡Atención!",
          text: "Debe adjuntar un comprobante del voucher",
          icon: "warning",
        });
        } else {
          this.progress = true;
        let datos = new FormData();
        datos.append("title", this.title);
        datos.append("description", this.description);

        datos.append("url_image", this.file);
    

        this.RegisterImageInvestP(datos)
          .then((response) => {
            console.log(response);
            if (response.code == 200) {
              Swal.fire({
                title: "Listo",
                text: "Nueva colocacion creada correctamente",
                icon: "success",
                showConfirmButton: false,
                timer: 1500,
              });
              this.progress = false;
              this.title = "";
              this.description = null;
              this.getDataUser();
              this.picture = null;
              
            } else if (response.message == "The amount must be over 500") {
              Swal.fire({
                title: "¡Atención!",
                text: "El monto debe ser mayor a $500",
                icon: "warning",
              });
              this.progress = false;
            } else {
               Swal.fire({
                title: "¡Atención!",
                text: "Error en las validaciones",
                icon: "warning",
              });
              this.progress = false;
            }
          })
          .catch((error) => {
            console.log(error);
            Swal.fire({
              title: "Error",
              text: "Ha ocurrido un error, intente más tarde",
              icon: "error",
            });
          });
        }
        
      }
    },

    updatePublicInvest() {
      if (
        this.form_update.title == "" ||
        this.form_update.description == ""
       
      ) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debes llenar todos los campos para continuar",
          icon: "warning",
        });
      } else {
        if ( this.amount <= 0){
        Swal.fire({
          title: "¡Atención!",
          text: "El monto a registrar debe ser mayor a 0",
          icon: "warning",
        });
        } else if ( !this.picture ){
          Swal.fire({
          title: "¡Atención!",
          text: "Debe adjuntar un comprobante del voucher",
          icon: "warning",
        });
        } else {
          this.progress = true;
        let datos = new FormData();
        datos.append("id", this.form_update.id);
        datos.append("title", this.form_update.title);
        datos.append("description", this.form_update.description);

        datos.append("url_image", this.file);
    

        this.UpdateImageInvestP(datos)
          .then((response) => {
            console.log(response);
            if (response.code == 200) {
              Swal.fire({
                title: "Listo",
                text: "Nueva colocacion creada correctamente",
                icon: "success",
                showConfirmButton: false,
                timer: 1500,
              });
              this.progress = false;
              this.title = "";
              this.description = null;
              this.getDataUser();
              this.picture = null;
              
            } else if (response.message == "The amount must be over 500") {
              Swal.fire({
                title: "¡Atención!",
                text: "El monto debe ser mayor a $500",
                icon: "warning",
              });
              this.progress = false;
            } else {
               Swal.fire({
                title: "¡Atención!",
                text: "Error en las validaciones",
                icon: "warning",
              });
              this.progress = false;
            }
          })
          .catch((error) => {
            console.log(error);
            Swal.fire({
              title: "Error",
              text: "Ha ocurrido un error, intente más tarde",
              icon: "error",
            });
          });
        }
        
      }
    },
    
   

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getDataUser() {
      this.isBusy = true;
      this.InvestPublicAll()
        .then((response) => {
          if (response.code == 200) {
            this.UsersTmp = response.data;
            this.totalRows = response.data.length;
            this.isBusy = false;
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Ha ocurrido un error",
            text: "Intente más tarde",
            icon: "warning",
          });
        });
    },
   
    changeActive(data) {
      let active = data.active === 1 ? 0 : 1;
    //  let action = data.actions ? false : true;
      let status =
        data.active === 1
          ? "Desactivado correctamente"
          : "Activado correctamente";
      console.log(data);
      let form = {
        id: data.id,
        url: 'placement/change_status',
        status: active,
      };

      this.changeStatusData(form)
        .then((response) => {
          if (response.code === 200) {
            console.log("te ejecutas?")
            Swal.fire({
              title: status,
              icon: "success",
              showConfirmButton: false,
              showLoaderOnConfirm: true,
              timer: 1000,
            });
            this.getDataUser();

          }
        })
        .catch((error) => {
          console.log(error);
          alert("Ocurrió un error, intente más tarde");
          // this.getDataUser();

          // this.AllUsers();
        });
    },
    deleteUser(data) {
      Swal.fire({
        title: "Atención",
        text:
          "¿Está seguro que desea eliminar a " +
          data.title +
          "?",
        icon: "question",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: "#121419",
        confirmButtonText: "Sí, seguro",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {




          let form = {
            id: data.id,
            url: 'placement/change_status',
            status: 2,
          };

          this.changeStatusData(form)
            .then((response) => {
              if (response.code === 200) {
                console.log("te ejecutas?")
                data.active = 2;
                Swal.fire({
                  title: "Colocación eliminada correctamente",
                  icon: "success",
                  showConfirmButton: false,
                  showLoaderOnConfirm: true,
                  timer: 1000,
                });
                this.getDataUser();

              }
            })
            .catch((error) => {
              console.log(error);
              alert("Ocurrió un errorxx, intente más tarde");
              // this.getDataUser();

              // this.AllUsers();
            });

        }
      });
    },
    userDetails(data) {
      // this.$store.commit('CHATROOM', data.room_id)
     this.modalUpdate = true;
     this.form_update = data;
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.onSubmitRegister();
    },
    resetModal() {
      this.$nextTick(() => {
        this.$bvModal.hide("modal-register");
      });
      this.RecoveryEmail = "";
      this.NameState = null;
      this.name = "";
      this.last_name = "";
      this.email_register = "";
      this.country = "";
      this.state = "";
      this.phone = "";
      this.password1 = "";
      this.password2 = null;
    },
  

  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&display=swap");
</style>